// Keeps the focused input above the keyboard on every platform.
// Android (Expo SDK 54+ draws edge to edge) no longer shrinks the window for the keyboard, so the screen
// must pad itself. React Native's KeyboardAvoidingView measures "my bottom edge minus the keyboard's top"
// against the screen, while the content starts below the header — hence the header height as offset.
// iOS keeps each screen's proven settings (content runs under the translucent header, so no offset).
import React from 'react';
import { KeyboardAvoidingView, Platform, StyleSheet, ViewStyle } from 'react-native';
// @react-navigation/elements ships with native-stack (pinned by package-lock.json); not a direct dependency on purpose —
// adding it bumped react-navigation and React in the lockfile, which the installed builds must not drift from.
import { useHeaderHeight } from '@react-navigation/elements';

export function KeyboardShift({ children, style, iosBehavior, iosOffset = 0 }: {
  children: React.ReactNode; style?: ViewStyle; iosBehavior?: 'padding' | 'height' | 'position'; iosOffset?: number;
}) {
  const headerHeight = useHeaderHeightSafe();
  const android = Platform.OS === 'android';
  return (
    <KeyboardAvoidingView
      style={[styles.flex, style]}
      behavior={android ? 'padding' : iosBehavior}
      keyboardVerticalOffset={android ? headerHeight : iosOffset}
    >
      {children}
    </KeyboardAvoidingView>
  );
}

function useHeaderHeightSafe(): number {
  try { return useHeaderHeight(); } catch { return 0; } // screens without a header (Login) have no header context
}

const styles = StyleSheet.create({ flex: { flex: 1 } });
